import { Injectable } from '@angular/core';
import { CommonService } from "../common.service";
import { UserPreference } from '../../models';
import { WidgethelperService } from "../widgethelper.service";
import { AnalyticsService } from "../analytics.service";
import { BaseService } from "./base.service";
import { errorMessages, appSettings } from "../../settings";
import { ZoneBalancingParam } from '../../models/ZoneBalancingParam';

@Injectable()
export class ZonebalancingService extends BaseService {

  constructor(private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService,) {
      super();
  }

  init(widget: any) {   
    widget.dataLoaded = false;
    widget.Title = 'Zone Balancing Report';

    let userPref: UserPreference = this._commonService.getUserPreference();

    let param = new ZoneBalancingParam();
    param.CustomerId = userPref.CustomerId;
    param.FacilityId = userPref.FacilityId;
    param.ProductivityInput = 200;
    param.DesiredHourlyUnits = 2000;
    let criteria = widget.widgetsettings.Criteria ? JSON.parse(widget.widgetsettings.Criteria) : null;
    if(criteria){
      param.ProductivityInput = criteria.ProductivityInput ? criteria.ProductivityInput : 200;
      param.DesiredHourlyUnits = criteria.DesiredHourlyUnits ? criteria.DesiredHourlyUnits : 2000;
    }

    this._analyticsService.getZoneBalancingSummary(param)
      .subscribe((result: any) => {       
        widget.errorMessage = null;
        if (result && result.length > 0) {
          widget.dataLoaded = false;
          let totalUnits = []; 
          let totalPickers = []; 
          let hourlyUnits = []; 
          let hourlyLaborNeed = []; 
          result.forEach(el => {
            totalUnits.push(el.TotalUnits);
            totalPickers.push(el.TotalPickers);
            hourlyUnits.push(el.HourlyUnits);
            hourlyLaborNeed.push(el.HourlyLaborNeed);            
          });  
          
          widget.chartOptions = this.chartOptions();
          this.addDataSeries(widget.chartOptions,totalUnits,'Total Units to be Picked','bar')
          this.addDataSeries(widget.chartOptions,totalPickers,'Total Active Pickers','bar')  
          this.addDataSeries(widget.chartOptions,hourlyUnits,'Projected Hourly Units','bar')       
          this.addDataSeries(widget.chartOptions,hourlyLaborNeed,'Labor Need for Desired Hourly Units - Over (Under)','bar')                    
          widget.chartOptions.xAxis.data = ['Zone Balancing Summary'];   
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;

       },
       err => {
        console.log('gethospitalordersummary', err);
        widget.errorMessage = errorMessages.apiError;
        widget.dataLoaded = true;
      }
    );
  }

  reload(widget: any) { }

  remove(widget: any) { }

}




// WEBPACK FOOTER //
// ./src/app/services/widgets/zonebalancing.service.ts